import { Injectable } from '@angular/core';

import { DataSecurityService } from './data-security.service';

@Injectable()
export class WebDataSecurityService extends DataSecurityService {

    public get securityLevel(): DataSecurityLevel {
        return DataSecurityLevel.Full;
    }
}
